import { colorsPalettes } from "@similarweb/styles";

import { EDataType } from "../../advertisers/overview/components/types";

import type { ChannelId, IChannelConfig } from "./types";

export const CHART_DIMENSIONS = {
    height: 150,
    width: 150,
} as const;

export const CHANNEL_IDS = {
    display: "display",
    search: "search",
    social: "social",
} as const;

export const CHANNEL_CONFIG: Record<ChannelId, IChannelConfig> = {
    [CHANNEL_IDS.display]: {
        color: colorsPalettes.blue[500],
    },
    [CHANNEL_IDS.search]: {
        color: colorsPalettes.midnight[500],
    },
    [CHANNEL_IDS.social]: {
        color: colorsPalettes.carbon[200],
        hasNoMetricData: true,
    },
};

export const METRICS_CONFIG = [EDataType.SPEND, EDataType.IMPRESSIONS, EDataType.VISITS] as const;
